var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM14 4.25H19C19.0129 4.25 19.0258 4.25033 19.0386 4.25098C19.1262 4.25542 19.2099 4.27491 19.2871 4.30691C19.3755 4.34351 19.4584 4.39776 19.5303 4.46967C19.6768 4.61612 19.75 4.80806 19.75 5V10C19.75 10.4142 19.4142 10.75 19 10.75C18.5858 10.75 18.25 10.4142 18.25 10V6.81066L6.81066 18.25H10C10.4142 18.25 10.75 18.5858 10.75 19C10.75 19.4142 10.4142 19.75 10 19.75H5C4.80806 19.75 4.61612 19.6768 4.46967 19.5303C4.39776 19.4584 4.34351 19.3755 4.30691 19.2871C4.27491 19.2099 4.25542 19.1262 4.25098 19.0386C4.25033 19.0258 4.25 19.0129 4.25 19V14C4.25 13.5858 4.58579 13.25 5 13.25C5.41421 13.25 5.75 13.5858 5.75 14V17.1893L17.1893 5.75H14C13.5858 5.75 13.25 5.41421 13.25 5C13.25 4.58579 13.5858 4.25 14 4.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize);
export default __webpack_public_path__ + "static/media/resize.4f8f550831b5c752529e4a46760512e5.svg";
export { ForwardRef as ReactComponent };